import Reveal, { SectionHead } from "./Reveal";

const IMG = "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxjaHVyY2glMjBjb25ncmVnYXRpb24lMjB3b3JzaGlwJTIwcGFzdG9yJTIwc2VybW9ufGVufDB8fHx8MTc4OTA1Mzk3NXww&ixlib=rb-4.1.0&q=85";

export default function Proof() {
  return (
    <section id="proof" data-testid="proof-section" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8 bg-navy-surface/40">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -inset-3 border border-gold/30 -translate-x-4 translate-y-4 pointer-events-none" />
          <img src={IMG} alt="Congregation in worship"
            className="relative w-full h-[24rem] lg:h-[30rem] object-cover grayscale-[30%] contrast-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy/85 via-transparent to-transparent" />
          <p className="absolute bottom-5 left-5 right-5 text-[10px] tracking-[0.25em] uppercase text-gold font-faith">
            Fountain of Living Water Apostolic Church — The Ministry Laboratory
          </p>
        </Reveal>
        <div className="order-1 lg:order-2">
          <SectionHead eyebrow="The Proof" title="Built From Ministry, Not Just Marketing." />
          <Reveal delay={0.1}>
            <p className="mt-8 text-sm sm:text-base text-slate-300 leading-relaxed">
              Minister of Social Media™ is built from real church experience — not generic corporate marketing
              theory. Using the digital foundation developed through
              <span className="text-white font-semibold"> Fountain of Living Water Apostolic Church (F.O.L.W.A.C.) </span>
              as the proof-of-concept environment, we understand that ministry content must do more than “look good.”
              It must carry clarity, integrity, invitation, and Kingdom purpose.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <blockquote className="mt-10 border-l-2 border-gold pl-6" data-testid="proof-quote">
              <p className="font-cormorant italic text-xl sm:text-2xl text-amber-100/90 leading-snug">
                “We do not market hype. We create visibility for the ministry God has already entrusted to you.”
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
